import { render, staticRenderFns } from "./subSideBar.vue?vue&type=template&id=27bbbe96&scoped=true&"
import script from "./subSideBar.vue?vue&type=script&lang=js&"
export * from "./subSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bbbe96",
  null
  
)

export default component.exports